class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    // this.resetButton = this.querySelector('button[type="reset"]');
    this.inputWrap = this.querySelector(".predictive-search_input-wrap");
    this.overlay = document.querySelector(".header_overlay");

    this.filterQuery = null;

    if (this.input) {
      //   this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  //   toggleResetButton() {
  //       const resetIsHidden = this.resetButton.classList.contains('hidden');
  //       if (this.input.value.length > 0 && resetIsHidden) {
  //         this.resetButton.classList.remove('hidden');
  //       } else if (this.input.value.length === 0 && !resetIsHidden) {
  //         this.resetButton.classList.add('hidden');
  //       }
  //   }

  onChange() {
    // this.toggleResetButton();
  }

  //   shouldResetForm() {
  //     return !document.querySelector('[aria-selected="true"] a');
  //   }

  //   onFormReset(event) {
  //     // Prevent default so the form reset doesn't set the value gotten from the url on page load
  //     event.preventDefault();
  //     // Don't reset if the user has selected an element on the predictive search dropdown
  //     if (this.shouldResetForm()) {
  //       this.input.value = '';
  //       this.input.focus();
  //       this.toggleResetButton();
  //     }
  //   }
}

customElements.define("search-form", SearchForm);

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.select = this.querySelector("select");
    this.filterSpan = this.querySelector(
      ".predictive-search_filter-label span"
    );
    this.searchTermSpan = null;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.select.addEventListener("change", this.onFilterSelect.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onFilterSelect(event) {
    this.filterQuery = event.target.selectedOptions[0].value;

    if (this.filterQuery === "*") {
      this.filterSpan.innerText = event.target.selectedOptions[0].innerText;
    } else {
      this.filterSpan.innerText = event.target.value;
    }
    this.getSearchResults(this.searchTerm, this.filterQuery);
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm, this.filterQuery);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );

    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(
        previousTerm,
        "laskldjlsk"
      );
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm, productType) {
    console.log(searchTerm, productType);

    const queryKey = `${searchTerm}-${productType || ""}`
      .toLowerCase()
      .replace(" ", "-");
    let filterQuery = `${encodeURIComponent(searchTerm)}`;

    if (productType) {
      filterQuery = `product_type:${productType} AND ${encodeURIComponent(
        searchTerm
      )}`;
    } else {
      filterQuery = encodeURIComponent(searchTerm);
    }

    console.log(filterQuery);

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${filterQuery}&resources[options][fields]=title,product_type,variants.title,variants.sku,tag&section_id=predictive-search`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );

        this.renderSearchResults(resultsMarkup, searchTerm);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  // renderSearchResults(resultsMarkup, searchTerm) {
  //   fetch(`/search?q=${searchTerm}&view=api`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Parse resultsMarkup into a DOM element if it's a string
  //       let parser = new DOMParser();
  //       let parsedMarkup = parser.parseFromString(resultsMarkup, "text/html");

  //       // Update the search count in the parsed DOM
  //       let countElement = parsedMarkup.querySelector(
  //         "[data-predictive-search-count]"
  //       );
  //       if (countElement) {
  //         countElement.innerText = window.searchStrings.searchResults.replace(
  //           "[count]",
  //           data.products_count
  //         );
  //       }

  //       // Update the predictive search results container
  //       this.predictiveSearchResults.innerHTML = parsedMarkup.body.innerHTML;
  //       this.setAttribute("results", true);

  //       // Open the predictive search results
  //       this.open();
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching full search results:", error);
  //     });
  // }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.searchTermSpan = this.querySelector(
      "#data-predictive-search-search-for-text"
    );

    this.searchTermSpan.innerText =
      window.searchStrings.predictiveSearchTerms.replace(
        "[terms]",
        this.searchTerm
      );

    if (this.searchTerm.length == 0) {
      this.querySelector(".predictive-search_button").classList.add("hidden");
    }

    // Open the predictive search results
    this.open();
  }

  //

  open() {
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    this.predictiveSearchResults.style.display = "block";
    this.inputWrap.style.borderRadius = "6px 6px 0px 0px";
    this.overlay.classList.remove("hidden");
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    this.inputWrap.style.borderRadius = "";
    this.overlay.classList.add("hidden");
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.style.display = "none";
  }
}

customElements.define("predictive-search", PredictiveSearch);
